import { vectors } from '@minware/ui-minware';
export const navBarItems = [
  {
    label: 'Product',
    heading: 'Product',
    separator: true,
    items: [
      {
        heading: 'Insights & Metrics',
        separator: true,
      },
      {
        label: 'AI Impact',
        link: '/product/insights/ai-impact',
        icon: vectors.robot,
      },
      {
        label: 'Quality',
        link: '/product/insights/quality',
        icon: vectors.bug,
      },
      {
        label: 'Predictability',
        link: '/product/insights/predictability',
        icon: vectors.targetCircles,
      },
      {
        label: 'Efficiency',
        link: '/product/insights/efficiency',
        icon: vectors.timer,
      },
    ],
  },
  {
    label: 'Pricing',
    link: '/pricing?from=nav',
  },
  {
    label: 'Contact',
    link: '/contact?from=nav',
  },
  {
    label: 'Resources',
    heading: 'Resources',
    separator: true,
    items: [
      {
        label: 'Live Demo',
        link: '/org/demo',
      },
      {
        label: 'Documentation',
        link: '/docs',
      },
      /* TODO when ready: uncomment
      {
        label: 'Software Engineering Guide',
        link: '/guide',
      },
      */
      {
        label: 'Lean AI Framework',
        link: '/lean-ai-framework',
      },
      {
        label: 'Security & Privacy',
        link: '/docs/security',
      },
      {
        label: 'About',
        link: '/about',
      },
      {
        label: 'Blog',
        link: '/blog',
      },
    ],
  },
]